"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Avatar_1 = __importDefault(require("@mui/material/Avatar"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var ThumbnailWithSpinner = function (_a) {
    var src = _a.src, alt = _a.alt;
    var _b = (0, react_1.useState)(false), loaded = _b[0], setLoaded = _b[1];
    return (react_1.default.createElement("div", { style: { position: "relative", width: 40, height: 40 } },
        !loaded && (react_1.default.createElement("div", { style: {
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            } },
            react_1.default.createElement(q_play_components_1.Spinner, null))),
        react_1.default.createElement(Avatar_1.default, { src: src, alt: alt, variant: "square", imgProps: {
                onLoad: function () { return setLoaded(true); },
                onError: function () { return setLoaded(true); },
            }, style: {
                visibility: loaded ? "visible" : "hidden",
                width: "100%",
                height: "100%",
            } })));
};
exports.default = ThumbnailWithSpinner;
